import { render } from "./Select2.vue?vue&type=template&id=49673dc8&scoped=true"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"

import "./Select2.vue?vue&type=style&index=0&id=49673dc8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49673dc8"]])

export default __exports__